// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scrollable Container Utilities */

/* Base scrollable container with custom scrollbar */
.scrollable {
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
}

/* Minimal styled scrollbar */
.scrollable::-webkit-scrollbar {
  width: 6px;
}

.scrollable::-webkit-scrollbar-track {
  background: transparent;
}

.scrollable::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 3px;
  -webkit-transition: background 0.2s ease;
  transition: background 0.2s ease;
}

.scrollable::-webkit-scrollbar-thumb:hover {
  background: #94A3B8;
}

/* Firefox scrollbar styling */
.scrollable {
  scrollbar-width: thin;
  scrollbar-color: #CBD5E1 transparent;
}

/* Height variants */
.scrollable-sm {
  max-height: 200px;
}

.scrollable-md {
  max-height: 300px;
}

.scrollable-lg {
  max-height: 400px;
}

.scrollable-xl {
  max-height: 500px;
}

.scrollable-2xl {
  max-height: 600px;
}

/* Responsive height variants */
@media (min-width: 768px) {
  .md\\:scrollable-sm {
    max-height: 200px;
  }

  .md\\:scrollable-md {
    max-height: 300px;
  }

  .md\\:scrollable-lg {
    max-height: 400px;
  }

  .md\\:scrollable-xl {
    max-height: 500px;
  }

  .md\\:scrollable-2xl {
    max-height: 600px;
  }
}

@media (min-width: 1024px) {
  .lg\\:scrollable-sm {
    max-height: 200px;
  }

  .lg\\:scrollable-md {
    max-height: 300px;
  }

  .lg\\:scrollable-lg {
    max-height: 400px;
  }

  .lg\\:scrollable-xl {
    max-height: 500px;
  }

  .lg\\:scrollable-2xl {
    max-height: 600px;
  }
}

@media (min-width: 1280px) {
  .xl\\:scrollable-sm {
    max-height: 200px;
  }

  .xl\\:scrollable-md {
    max-height: 300px;
  }

  .xl\\:scrollable-lg {
    max-height: 400px;
  }

  .xl\\:scrollable-xl {
    max-height: 500px;
  }

  .xl\\:scrollable-2xl {
    max-height: 600px;
  }
}

/* Fade effect at bottom when scrollable */
.scrollable-fade {
  position: relative;
}

.scrollable-fade::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.9));
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.scrollable-fade.has-scroll::after {
  opacity: 1;
}

/* Padding adjustment for scrollable content */
.scrollable-content {
  padding-right: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/scrollable.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC,oDAAoD;AACpD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,6EAA6E;EAC7E,oBAAoB;EACpB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;AACpB","sourcesContent":["/* Scrollable Container Utilities */\n\n/* Base scrollable container with custom scrollbar */\n.scrollable {\n  overflow-y: auto;\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n}\n\n/* Minimal styled scrollbar */\n.scrollable::-webkit-scrollbar {\n  width: 6px;\n}\n\n.scrollable::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.scrollable::-webkit-scrollbar-thumb {\n  background: #CBD5E1;\n  border-radius: 3px;\n  transition: background 0.2s ease;\n}\n\n.scrollable::-webkit-scrollbar-thumb:hover {\n  background: #94A3B8;\n}\n\n/* Firefox scrollbar styling */\n.scrollable {\n  scrollbar-width: thin;\n  scrollbar-color: #CBD5E1 transparent;\n}\n\n/* Height variants */\n.scrollable-sm {\n  max-height: 200px;\n}\n\n.scrollable-md {\n  max-height: 300px;\n}\n\n.scrollable-lg {\n  max-height: 400px;\n}\n\n.scrollable-xl {\n  max-height: 500px;\n}\n\n.scrollable-2xl {\n  max-height: 600px;\n}\n\n/* Responsive height variants */\n@media (min-width: 768px) {\n  .md\\:scrollable-sm {\n    max-height: 200px;\n  }\n\n  .md\\:scrollable-md {\n    max-height: 300px;\n  }\n\n  .md\\:scrollable-lg {\n    max-height: 400px;\n  }\n\n  .md\\:scrollable-xl {\n    max-height: 500px;\n  }\n\n  .md\\:scrollable-2xl {\n    max-height: 600px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .lg\\:scrollable-sm {\n    max-height: 200px;\n  }\n\n  .lg\\:scrollable-md {\n    max-height: 300px;\n  }\n\n  .lg\\:scrollable-lg {\n    max-height: 400px;\n  }\n\n  .lg\\:scrollable-xl {\n    max-height: 500px;\n  }\n\n  .lg\\:scrollable-2xl {\n    max-height: 600px;\n  }\n}\n\n@media (min-width: 1280px) {\n  .xl\\:scrollable-sm {\n    max-height: 200px;\n  }\n\n  .xl\\:scrollable-md {\n    max-height: 300px;\n  }\n\n  .xl\\:scrollable-lg {\n    max-height: 400px;\n  }\n\n  .xl\\:scrollable-xl {\n    max-height: 500px;\n  }\n\n  .xl\\:scrollable-2xl {\n    max-height: 600px;\n  }\n}\n\n/* Fade effect at bottom when scrollable */\n.scrollable-fade {\n  position: relative;\n}\n\n.scrollable-fade::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 40px;\n  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.9));\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.scrollable-fade.has-scroll::after {\n  opacity: 1;\n}\n\n/* Padding adjustment for scrollable content */\n.scrollable-content {\n  padding-right: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
